import { useRef } from "react";
import "../styles/TestimonialsHome.css";
import { BiChevronLeftCircle, BiChevronRightCircle } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { MdOutlineStar } from "react-icons/md";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const items = [
  {
    name: "Anupam Mukerji",
    review:
      "I've had a great experience with Chetan Mahajan at Micro Inc. SMP. He's a real artist and a perfectionist. Goes the extra mile to make sure the desired results are achieved. I went to him for scar camouflage. He did that and a lot more. Given me a really good look. I will recommend anyone to go to him without blinking an eye. Your satisfaction is guaranteed.",
  },
  {
    name: "S Bose",
    review:
      "I recently had an outstanding experience with Mr. Chetan Mahajan for my SMP procedure. He is a truly talented artist who takes great care to ensure the scalp pigmentation is done flawlessly. He dedicates ample time to the process, ensuring that the desired results with precision. The clinic's ambiance is welcoming, and safety procedures followed, providing wonderful experience overall.If you're looking for the best person in Mumbai for scalp SMP, I highly recommend Micro Inc. SMP",
  },
  {
    name: "Hitz Anj",
    review:
      "I am extremely satisfied with the Hair Tattoo SMP service provided by Chetan. His professionalism, skill, and attention to detail truly stood out, making the entire experience seamless and enjoyable. The environment was impeccably clean and well-organised, which added an extra level of comfort and trust throughout the process. Chetan's dedication to delivering high-quality results and ensuring customer satisfaction was evident in every step. I genuinely appreciate the effort and expertise Chetan brought to the service, and I am thrilled with the outcome. I would highly recommend Chetan's Hair Tattoo SMP service to anyone seeking a professional and hygienic experience.",
  },
  {
    name: "Ashok",
    review:
      "For the past month, I had been searching for a solution to my hair loss. I looked into options like hair wigs and hair transplants, but I wasn’t fully convinced. That’s when I came across Scalp Micropigmentation (SMP) and decided to explore it further. However, in Navi Mumbai, I struggled to find anyone who could give me proper information about the procedure. Then I found Micro Inc. SMP and got in touch with Mr. Chetan Mahajan. From the very first consultation call, he patiently explained everything in detail, answering all my doubts and making me feel confident about the process. I decided to go ahead with SMP, and after completing my three sessions, I couldn’t be happier with the results! The transformation has not only improved my appearance but has also boosted my confidence. I’m truly grateful to Mr. Chetan for his expertise and professionalism.",
  },
  {
    name: "Great Saiyaman",
    review:
      "Having found out about this place by a chance encounter, I was glad to have had the opportunity to visit it (after pestering Mr Chetan Mahajan for 4 months). The hospitality, the patience, the cleanliness and the quality of the work is truly mind blowing. After every session I could feel magic happening, and after the last session it was truly a cathartic experience. What I had envisioned for my SMP was now present on my scalp and I couldnt be more grateful. Chetan is truly a master of his craft on top of being an amazing human being. If you are 100% sure you want an SMP, then this is 100% the place for you.",
  },
  {
    name: "Anuj Sharma",
    review:
      "Chetan sir is a fabulous human being. For him what matters the most is his client’s satisfaction and happiness. He puts in a lot of heart and effort towards achieving this goal. The importance of doing prior research on what’s most suitable for you cannot be overemphasised. In case of any doubts Chetan sir very patiently answers them. The business is also located in a very convenient location. The place is very clean and very well put up and maintained. Thanks Chetan sir for helping me out. Your art and skill has made a huge impactful difference in my life.",
  },
  {
    name: "Deepthi Divakaran",
    review:
      "I got the SMP procedure done at Micro Inc. What Chetan has achieved is nothing short of a miracle! Right from the first consultation Chetan made me feel at ease and his honesty came across very clearly during the conversation where he told me exactly what can be achieved. On arriving at his clinic, I found him to be an absolutely friendly and down-to-earth person whose skill was evident every step of the way, right from choosing the right colour to the way he handled the procedure, making it most comfortable and virtually painless. Chetan pays great attention to detail and he treats the scalp as a canvas on which his art unfolds with so much care and focus that the end result is a true masterpiece. I do not think I have words enough to truly describe my experience at Micro SMP. I went there as a client and came back having made a close friend.",
  },
  {
    name: "Meli 002",
    review:
      "I recently completed my Scalp Micropigmentation (SMP) treatment at Micro SMP Mumbai, and I am very happy with the results. From the very beginning, the entire experience has been nothing short of exceptional. The level of professionalism, precision, and care I received throughout the process was truly commendable. The work done by bro Chetan is outstanding, every session was carried out with incredible attention to detail, and the final outcome has exceeded all my expectations. The results look completely natural. It’s not just about the look, it’s about the confidence it brings back. I genuinely feel more comfortable and positive about my appearance, and it’s all thanks to the amazing work done here. I would absolutely recommend Micro Inc. SMP to anyone considering SMP.",
  },
  {
    name: "Nikhil Kelji",
    review:
      "I knew I had to get the smp done, but I was not getting the right artist to get it done as there are only 2-3 artists in India who specialize in smp and smp only. Luckily got my appointments for this guy and got what I exactly wanted. Chetan is not just an excellent smp artist but also a good human being. He loves his job and has a knack for hygeine making me more comfortable about the procedure. What I loved about him was his dedication. From start to the end of the process, he worked with the same enthu and energy. He did a fabulous job and I wish he continues to spread smiles in future. Kudos bro keep doing the good work and godspeed.",
  },
  {
    name: "Joaquim Carvalho",
    review:
      "I'm thrilled to share my experience with Micro Inc. SMP and the incredibly talented Mr. Chetan Mahajan! His expertise in scalp pigmentation is unmatched, and his guidance was impeccable. In just two sessions, he transformed my look with a remarkably natural appearance. His attention to detail, professionalism, and dedication are truly commendable. The clinic itself is a serene oasis, designed for comfort. If you're considering scalp pigmentation, look no further than Micro Inc. SMP and Mr. Mahajan. His artistry and the clinic's exceptional service will exceed your expectations.",
  },
  {
    name: "John Mumbai",
    review:
      "Literally the BEST PERSON to go to in Mumbai Atleast , for Your SMP needs ! Mr. Chetan is a well-trained Professional, Considerate about your scalp needs and Fantastic in his SMP work , providing EXCELLENT RESULTS ! This Gentleman starts with a Thorough Explanation of the procedure , its Suitability/Non-suitability for u , answers all yr queries and clears all your doubts. I went through my Sessions Easily in his Comfortable Studio and now am Thoroughly Satisfied with the Results !!!",
  },
  {
    name: "Vishal Jaiswar",
    review:
      "A few years ago, I started losing my hair, and whatever was left began thinning too. I lost almost 80% of it. But honestly, the hardest part wasn’t just the hair loss, it was how it took away my confidence. I started avoiding people and felt very low. I knew SMP could help, but I never thought it would look this good or this natural. It’s been a total game changer for me. My confidence is back, and the compliments I’ve been getting from friends and family feel amazing. If you’re dealing with hair loss, I’d 100% recommend SMP over anything else. A huge thanks to Chetan Sir for giving me this fresh, new look!",
  },
  {
    name: "Praveen Tirkey",
    review:
      "I discovered SMP while researching hair transplants. The more I learned, the more I realized it was the perfect choice. While searching for SMP studios in Mumbai, most were general cosmetic clinics, but you stood out as a true specialist. Knowing you had undergone SMP yourself and reading your reviews gave me complete confidence. From our first meeting, I felt comfortable and certain in my decision. Now, my confidence is boosted, my family loves my new look, and I couldn’t be happier. Micro Inc. SMP is the best choice!",
  },
  {
    name: "MyHome Engineering",
    review:
      "I recently underwent two Scalp Micropigmentation (SMP) sessions at Micro Inc, and it has been an outstanding experience. The studio is conveniently near Mahim Station, making it easily accessible. Mr. Chetan Mahajan handled the process with great expertise and attention to detail. The relaxing atmosphere, complemented by cool background music, made it even better. The results are precise and natural-looking. With one session left, I’m already thrilled. His hospitality, including a thoughtful meal, stood out. I confidently give Micro Inc. SMP a 5-star rating. Highly recommended!",
  },
  {
    name: "Nilesh More",
    review:
      "It was a wonderful experience with Chetan sir in his studio of Micro Inc. SMP. His experience, Passion and dedicated work is remarkable. Good Hygiene was maintained, pleasant atmosphere. He works with all his energy and enthusiasm and make client comfortable throughout the sessions . The most important thing is client satisfaction, he works till that extent where client gets satisfied from his work, Really Worth for money.",
  },
  {
    name: "Vinod Bhagat",
    review:
      "I don't usually write reviews, but I felt compelled to share my experience with Micro Inc SMP because of the exceptional quality of his work. The art of Scalp Micropigmentation (SMP) requires skill and finesse, and Chetan Mahajan from Micro Inc SMP is a Master. This procedure has been transformative. He gave me the confident I needed and a new look in life. He's such a perfectionist and took the time to do it right and make sure I'm happy with the result for anyone feeling stuck and looking for a change, I highly recommend Chetan’s Micro Inc SMP. Choosing Chetan Mahajan for your SMP treatment is a decision you won't regret. Forever grateful!",
  },
  {
    name: "Clara Thomas",
    review:
      "I dealt with hair loss as a woman for the past 3 years. I wasn't confident about how I looked. I tried almost every possible treatment to improve the condition but I wasn't happy. I was nervous at the start of the process but Chetan walked me through, explaining what he will be doing and made me comfortable. It was a painless process. Now my confidence is back and I can style and wear my hair in any way I want too. I can't thank Micro Inc. SMP enough for helping me bring this change in my life.",
  },
  {
    name: "Geroge Fernandes",
    review:
      "I recently had an exceptional experience at Micro Inc. SMP! The expertise at Micro Inc. SMP shone through as they patiently addressed all my queries, instilling in me a sense of confidence about the procedure. Under the skilled hands of Chetan Mahajan, I achieved natural-looking results that have significantly bolstered my self-assurance. Moreover, the minimal post-procedure care required is a definite advantage. I wholeheartedly recommend Micro Inc. for those seeking a non-surgical hair loss solution – it truly transformed my life! Special thanks to Chetan Mahajan for his outstanding work! As someone who sought hair treatment, I can confidently say that it's worth every penny.",
  },
  {
    name: "Uday Karkera",
    review:
      "Few years back, I was suggested to opt for a patch from a repute clinic as I lacked sufficient donor area for a hair transplant, a suggestion I didn't pursue. Recently, a close friend recommended I explore Micro Inc. SMP for SMP. There, I met Chetan Mahajan, the Picasso I would say, in his Mahim studio. The procedure itself was painless, although each session required a few hours at a stretch. Chetan's skills and crafty hands ensured my comfort throughout. This innovation is truly remarkable, offering individuals with sparse hair the opportunity to transform their appearance and regain their confidence. Now, I confidently affirm that 50 is the new 40 :)",
  },
  {
    name: "Ronak Motta",
    review:
      "I recently underwent the scalp micropigmentation procedure, and I couldn't be more thrilled with the results. As someone who has struggled with hair loss for years and have had a bald scalp, SMP has been a game-changer for me. From the initial consultation to the final session, the entire experience at Micro Inc. SMP was exceptional. The results exceeded my expectations. The skilled practitioner (Chetan Mahajan) meticulously created a natural-looking hairline that seamlessly blends with my existing hair. It's amazing how the treatment has significantly improved my confidence and overall appearance. “Yay I have a Hairline now”",
  },
];

function TestimonialsHome() {
  return (
    <div>
      <TestimonialsHomeMainDesktop></TestimonialsHomeMainDesktop>
      <TestimonialsHomeMainTablet></TestimonialsHomeMainTablet>
      <TestimonialsHomeMainMobile></TestimonialsHomeMainMobile>
    </div>
  );
}

function TestimonialsHomeMainDesktop() {
  const navigate = useNavigate();
  const styles = {
    buttonContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItms: "center",
      fontSize: "30px",
      margin: "0px 5px 0px 0px",
    },
    icon: {
      cursor: "pointer",
      color: "#c5c5c5",
    },
  };

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      const { scrollLeft } = scrollRef.current;
      if (scrollLeft > 0) {
        // Only scroll if not already at the start
        scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
      }
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      const maxScroll = scrollWidth - clientWidth;
      if (scrollLeft < maxScroll) {
        // Only scroll if not already at the end
        scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
      }
    }
  };

  return (
    <div className="testimonials-home-main-desktop">
      <div className="testimonials-home-head">
        <div className="testimonials-home-head-column">
          {/* <div className="testimonials-home-text2">Reviews</div> */}
          <img style={{width: '180px'}} src="/google-reviews.png"></img>
        </div>
        <div style={styles.buttonContainer}>
          <BiChevronLeftCircle onClick={scrollLeft} style={styles.icon} />
          <div style={{ width: "15px" }}></div>
          <BiChevronRightCircle onClick={scrollRight} style={styles.icon} />
        </div>
      </div>
      <div ref={scrollRef} className="testimonial-home-cards">
        {items.map((item, index) => (
          <div style={{ display: "inline-block" }} key={index}>
            <TestimonialCard text1={item.name} text2={item.review} />
            {index !== items.length - 1 && <div className="tc-space"></div>}
          </div>
        ))}
      </div>
    </div>
  );
}

function TestimonialsHomeMainTablet() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      const { scrollLeft } = scrollRef.current;
      if (scrollLeft > 0) {
        // Only scroll if not already at the start
        scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
      }
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      const maxScroll = scrollWidth - clientWidth;

      if (scrollLeft < maxScroll) {
        // Only scroll if not already at the end
        scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
      }
    }
  };
  return (
    <div className="testimonials-home-main-tablet">
      <div className="testimonials-home-head">
        <div className="testimonials-home-head-column">
          {/* <div className="testimonials-home-text2">Reviews</div> */}
          <img style={{width: '180px', marginBottom: '30px'}} src="/google-reviews.png"></img>
        </div>
      </div>
      <div
        style={{
          width: "80%",
          position: "relative",
          display: "flex",
        }}
      >
        <div ref={scrollRef} className="testimonial-home-cards1">
          {items.map((item, index) => (
            <div style={{ display: "inline" }} key={index}>
              <TestimonialCard text1={item.name} text2={item.review} />
              {index !== items.length - 1 && <div className="tc-space"></div>}
            </div>
          ))}
        </div>
        <button
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            color: "white",
            border: "none",
            padding: "10px 10px 10px 5px",
            borderRadius: "50%",
            width: "40px",
            height: "80px",
            borderRadius: "0px 45px 45px 0",
            cursor: "pointer",
            zIndex: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            left: "0px",
          }}
          onClick={() => scrollLeft()}
        >
          <FaChevronLeft size={25} />
        </button>
        <button
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            color: "white",
            border: "none",
            padding: "10px 5px 10px 10px",
            borderRadius: "50%",
            width: "40px",
            height: "80px",
            borderRadius: "45px 0 0 45px",
            cursor: "pointer",
            zIndex: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            right: "0px",
          }}
          onClick={() => scrollRight()}
        >
          <FaChevronRight size={25} />
        </button>
      </div>
    </div>
  );
}

function TestimonialsHomeMainMobile() {
  const navigate = useNavigate();
  const styles = {
    buttonContainer: {
      // backgroundColor: 'red',
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItms: "center",
      fontSize: "30px",
      margin: "0px 5px 0px 0px",
    },
    icon: {
      cursor: "pointer",
      color: "#c5c5c5",
    },
  };

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      const { scrollLeft } = scrollRef.current;
      if (scrollLeft > 0) {
        // Only scroll if not already at the start
        scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
      }
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      const maxScroll = scrollWidth - clientWidth;

      if (scrollLeft < maxScroll) {
        // Only scroll if not already at the end
        scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
      }
    }
  };

  return (
    <div className="testimonials-home-main-mobile">
      <div className="testimonials-home-head">
        <div className="testimonials-home-head-column">
          {/* <div className="testimonials-home-text2">Reviews</div> */}
          <img style={{width: '150px', marginBottom: '30px'}} src="/google-reviews.png"></img>
        </div>
      </div>
      <div
        style={{
          width: "90%",
          position: "relative",
          display: "flex",
        }}
      >
        <div ref={scrollRef} className="testimonial-home-cards">
          {items.map((item, index) => (
            <div style={{ display: "inline" }} key={index}>
              <TestimonialCard text1={item.name} text2={item.review} />
              {index !== items.length - 1 && <div className="tc-space"></div>}
            </div>
          ))}
        </div>
        <button
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            color: "white",
            border: "none",
            padding: "10px 10px 10px 5px",
            borderRadius: "50%",
            width: "40px",
            height: "80px",
            borderRadius: "0px 45px 45px 0",
            cursor: "pointer",
            zIndex: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            left: "0px",
          }}
          onClick={() => scrollLeft()}
        >
          <FaChevronLeft size={25} />
        </button>
        <button
          style={{
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            color: "white",
            border: "none",
            padding: "10px 5px 10px 10px",
            borderRadius: "50%",
            width: "40px",
            height: "80px",
            borderRadius: "45px 0 0 45px",
            cursor: "pointer",
            zIndex: "1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            right: "0px",
          }}
          onClick={() => scrollRight()}
        >
          <FaChevronRight size={25} />
        </button>
      </div>
    </div>
  );
}

function TestimonialCard({
  text1,
  text2,
  text3,
  image1,
  image2,
  onClickAction,
}) {
  return (
    <div className="testimonial-home-card-component-container">
      <div className="testimonial-home-card-component-in">
        <div className="testimonial-home-card-component-content-area">
          <div className="testimonial-home-card-component-text0">
            {text1}
            <div style={{ display: "flex", flexDirection: "row" }}>
              <MdOutlineStar style={{ color: "#e9be47" }} />
              <MdOutlineStar style={{ color: "#e9be47" }} />
              <MdOutlineStar style={{ color: "#e9be47" }} />
              <MdOutlineStar style={{ color: "#e9be47" }} />
              <MdOutlineStar style={{ color: "#e9be47" }} />
            </div>
          </div>
          <div className="testimonial-home-card-component-text1">"{text2}"</div>
        </div>
      </div>
    </div>
  );
}

export default TestimonialsHome;